import { localDateToString } from "@shared/utils/formatters/dates"
import { ResolvedFleetEntry } from "../../../../../api/fleet"

export type Data = Omit<ResolvedFleetEntry, "onCoverDate" | "offCoverDate"> & {
  onCoverDate: string
  offCoverDate: string | null
  abiGroupString: string
}

export const data = (currentVehicles: ReadonlyArray<ResolvedFleetEntry>) =>
  currentVehicles.map((it) => ({
    ...it,
    onCoverDate: localDateToString(it.onCoverDate),
    offCoverDate: it.offCoverDate ? localDateToString(it.offCoverDate) : null,
    abiGroupString: abiGroupTransform(it.abiGroup, it.type),
  }))

export const abiGroupTransform = (abiGroup: number | null, type: string | null): string => {
  switch (type) {
    case `lcv`:
      return `VAN`
    case `hgv`:
      return `HGV`
    default:
      return abiGroup ? abiGroup.toString() : ``
  }
}
